import { LinkCategory } from '../enum/linkcategory';

export class Link {
  name: string;
  url: string;
  categoryName: string;
  category: LinkCategory;
}
